const CategoryAhanPageORGFA = [
    {
        ID : 3001 ,
        Name: " پروفیل ",
        ImageURL: "image/cat-1-1.jpg",
        CategoryID:  2001, 
        CompanyName: "تهران",
        Details: "2میل 20 * 10",
    },
    {
        ID : 3077 ,
        Name: " نبشی ",
        ImageURL: "image/cat-1-2.jpg",
        CategoryID:  2002, 
        CompanyName: "آریان فولاد",
        Details: "ضخامت 7 - 70 * 70",
    },
    {
        ID : 3163 ,
        Name: " تیرآهن ",
        ImageURL: "image/cat-1-3.jpg",
        CategoryID:  2003, 
        CompanyName: "ذوب آهن",
        Details: "14 بنگاه اصفهان",
    },
    {
        ID : 3203 ,
        Name: " میلگرد ",
        ImageURL: "image/cat-1-4.jpg",
        CategoryID:  2004, 
        CompanyName: " اصفهان ",
        Details: " A3 - 14",
    },
    {
        ID : 3005 ,
        Name: " ورق استنلس استیل ",
        ImageURL: "image/cat-1-5.jpg",
        CategoryID:  2005, 
        CompanyName: "تهران",
        Details: "" ,
    },
    {
        ID : 3006 ,
        Name: " ورق ",
        ImageURL: "image/new-cat-1-1.jpg",
        CategoryID:  2006, 
        CompanyName: "تهران",
        Details: "" ,
    },
    {
        ID : 3007 ,
        Name: " لوله ",
        ImageURL: "image/cat-1-8.jpg",
        CategoryID: 2007 , 
        CompanyName: "تهران",
        Details: "" ,
    },
    {
        ID : 3008 ,
        Name: " محصولات مفتولی ",
        ImageURL: "image/cat-1-9.jpg",
        CategoryID:  2008, 
        CompanyName: "تهران",
        Details: "" ,
    },
]

export default CategoryAhanPageORGFA;